<template>
  <v-layout row wrap v-if="i18next">
    <v-flex xs12 sm5 md4>
      <v-card>
        
        <v-list subheader>
          <template v-if="$route.params.level1" >
            <v-subheader>{{$route.params.level1 | capitalize}}</v-subheader>
            <v-list-item v-for="(val, key) in i18next['en']['translation'][$route.params.level1]" :key="key" :href="getEditTextLink($route.params.level1, key)">
              <v-list-item-content>
                <v-list-item-title v-if="key === $route.params.level2"><b>{{ val }}</b></v-list-item-title>
                <v-list-item-title v-else>{{ val }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>

          <v-divider></v-divider>

          <v-subheader>Kategorien</v-subheader>
          <v-list-item v-for="header in accordionKeys" :key="header" :href="getEditTextLink(header)">
            <v-list-item-content>
              <v-list-item-title v-if="header === $route.params.level1"><b>{{ header | capitalize }}</b></v-list-item-title>
              <v-list-item-title v-else>{{ header | capitalize }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-flex>
    <v-flex xs12 sm7 md8>
      <v-card style="min-height: 20px; padding-top: 20px;">
        <router-view  v-if="$route.params.level2" :texts="texts" @save="config => saveTexts(config)"></router-view>
        
      </v-card>
      
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex'

  export default {

    data() {
      return {
        selectedHeader: null
      }
    },

    props: {
      texts: {
        type: Object,
        required: true,
        default: () => ({})
      },
      baseUrl: {
        type: String,
        required: true
      }
    },

    computed: {
      ...mapState('texts', [
        'i18next',
        'accordionKeys'
      ])
    },

    methods: {
      saveTexts(texts) {
        this.$emit('saveTexts', texts)
      },
      getEditTextLink(level1, level2) {
        if(!level2) {
          return `#${this.baseUrl}/texts/consumer/${level1}`;
        }
        return `#${this.baseUrl}/texts/consumer/${level1}/${level2}`;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// IsrsTextsDialog.vue?ceccc220